import { render } from "./Payables.vue?vue&type=template&id=13bd2326"
import script from "./Payables.vue?vue&type=script&lang=js"
export * from "./Payables.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__